import {Component, OnInit} from '@angular/core';
import {UiContext, UiSettingsService} from '../../../shared/ui-settings.service';
import {Router} from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { environment } from '../../../../environments/environment';
import { preventDisasterButton } from '~app/shared/utils';

/**
 * Class for application. Wraps other components.
 */
@Component({
  selector: 'qm-superuser',
  templateUrl: './superuser.component.html',
  styleUrls: ['./superuser.component.scss']
})
export class SuperuserComponent implements OnInit {
  title = 'Rego Manager';
  isCollapsed = true;

  /**
   * From which route the user originally switched to Superuser from
   */
  public originRoute?: string;
  public uiContext: UiContext;

  /**
   * Initializes the component.
   * @param uiSettingsService Service for setting contexts.
   * @param router Router component.
   * @param auth Auth component to manage authentication.
   */
  constructor(public uiSettingsService: UiSettingsService,
              private router: Router,
              private auth: AuthService
              ) {
    const navigation = this.router.getCurrentNavigation();
    try {
      this.originRoute = navigation.extras.state.originRoute;
      console.log(`Navigated to superuser from: ${this.originRoute}`);
    } catch(e) {}
  }

  /**
   * Inits the component.
   */
  ngOnInit(): void {
    this.uiContext = this.uiSettingsService.getContextByBuildTarget(environment.buildTarget);
    preventDisasterButton();
  }

  /**
   * Log out.
   */
  public logout(): void {
    this.auth.logout();
  }

  public getAllowedContexts() {
    if (environment.buildTarget === 'master') {
      return this.uiSettingsService.getContexts();
    }

    return this.uiSettingsService.getContexts().filter(context => {
      return context.productionOnly === false;
    });
  }

  /**
   * When the context (develop / production...) button had been clicked.
   * @param context The clicked button.
   */
  async contextButtonPressed(context: UiContext): Promise<void> {
    this.uiSettingsService.selectContext(context);
    try {
      await this.router.navigateByUrl(this.router.url);
    } catch (error) {
      console.error('Error when reloading the page after a context change: ' + error);
    }
  }
}
